import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class EventRecord extends RecordBase {

  static defaultAttributes = {
    abrupt_braking_count:           '',
    distance:                       '',
    end_date:                       '',
    event_type:                     '',
    fast_acceleration_count:        '',
    hard_turns_count:               '',
    high_speed_count:               '',
    id:                             '',
    max_speed_reached:              '',
    provider:                       '',
    start_date:                     '',
    use_phone_count:                '',
    address:                        '',
    average_speed:                  null,
    event_teams:                    [],
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    if(!this._attributeNames){
      this._attributeNames = {
        id:                         t('person.attributes.id'),
        abrupt_braking_count:       t('person.attributes.abrup_braking_count'),
        distance:                   t('person.attributes.distance'),
        end_date:                   t('person.attributes.end_date'),
        event_type:                 t('person.attributes.event_type'),
        fast_acceleration_count:    t('person.attributes.fast_acceleration_count'),
        hard_turns_count:           t('person.attributes.hard_turns_count'),
        high_speed_count:           t('person.attributes.high_speed_count'),
        max_speed_reached:          t('person.attributes.max_speed_reached'),
        provider:                   t('person.attributes.provider'),
        start_date:                 t('person.attributes.start_date'),
        use_phone_count:            t('person.attributes.use_phone_count'),
        address:                    t('person.attributes.address'),
        average_speed:              t('person.attributes.average_speed'),
      };
    }

    return this._attributeNames;
  }

  toParams(){
    const {
      id,
      abrupt_braking_count,
      distance,
      end_date,
      event_type,
      fast_acceleration_count,
      hard_turns_count,
      high_speed_count,
      max_speed_reached,
      provider,
      start_date,
      use_phone_count,
      address,
      address_end,
      average_speed,
    } = this.toObject();

    return {
      data:{
        attributes:{
          id,
          abrupt_braking_count,
          distance,
          end_date,
          event_type,
          fast_acceleration_count,
          hard_turns_count,
          high_speed_count,
          max_speed_reached,
          provider,
          start_date,
          use_phone_count,
          address,
          address_end,
          average_speed
        }
      }
    };
  }
}
